import React from 'react';
import { LinkButton } from '../LinkButton';

export class QuickForm extends React.Component{
    render(){
        return(
            <div className="col-sm-4 content">
                <article>
                            <h2>Onneksi olkoon!</h2>
                            <p>Pyöräytit itsellesi pienen piristyksen. Saat sen osaston henkilökunnalta. Muista osallistua myös leffalippupaketin arvontaan.</p>
                            
                            <LinkButton to="/form" class="btn-green" text="Osallistu arvontaan" />
                            <LinkButton to="/" class="btn-white" text="En osallistu arvontaan" />
                </article>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/views/QuickForm.js